// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__V82ae","boxTitle":"Qualiphy_boxTitle__3h04P","box":"Qualiphy_box__1tpMf","toggleWrap":"Qualiphy_toggleWrap__2oA9Q"};